import { render } from "./city-houses-section.vue?vue&type=template&id=14dd54f8"
import script from "./city-houses-section.vue?vue&type=script&lang=js"
export * from "./city-houses-section.vue?vue&type=script&lang=js"

import "./city-houses-section.vue?vue&type=style&index=0&id=14dd54f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__